import { IHttpResponse } from 'angular';
import { Collection } from '../../app/spaces/Collections/CollectionModels';
import { GetCollectionsResponse } from '../../app/spaces/Collections/Collections';
import { ICollectionInfo } from '../../app/spaces/Collections/ICollectionInfo';
import { ListResult } from '../fetchers/ListResult';
import { MapperHelper } from './MapperHelper';

export module CollectionMapper {
  export function mapsSingle(response: IHttpResponse<Collection>): ICollectionInfo {
    const collection = response.data;
    return {
      id: collection.id,
      name: collection.name,
      description: collection.description,
      contentType: 'collection',
      itemCount: collection.itemCount,
      userId: collection.userId,
      visibility: collection.visibility,
      createdAt: MapperHelper.toDate(collection.createdAt),
    };
  }

  export function mapList(response: IHttpResponse<GetCollectionsResponse>, start: number): ListResult<ICollectionInfo> {
    return {
      items: response.data.items.map((item: Collection) => {
        return {
          id: item.id,
          name: item.name,
          description: item.description,
          contentType: 'collection',
          itemCount: item.itemCount,
          userId: item.userId,
          visibility: item.visibility,
          createdAt: MapperHelper.toDate(item.createdAt),
        };
      }),
      total: response.data.totalCount,
      index: start
    };
  }

  export function mapFromCRASS(content: any): ICollectionInfo {
    return {
      contentType: 'collection',
      name: content.name,
      id: content.id,
      userId: content.ownerId,
      itemCount: content.itemNames.length,
      visibility: content.visibility,
      description: content.description,
      createdAt: null, // MapperHelper.toDate(item.createdAt), TFSID:1067707
    };
  }
}
